const API_FILE_SIGNED_URL_URI = '/api/file/signed-url/';

export async function getSignedUrl(file) {
  const contentType = file.type;
  const response = await fetch(API_FILE_SIGNED_URL_URI, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({contentType})
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return response.json();
}

